import React from 'react';

export const EmptyShippingMessage = () => {
  return <div className="shipping__empty" />;
};
